/**
 * Trip assignment intake methods — how trips are dispatched to the provider.
 * Mirrors the enum defined in kinetik-account-service
 * (src/domain/constants/tripTransmissionMethods.js).
 */
export const ASSIGNMENT_INTAKE_METHOD_TRIPS = Object.freeze({
  KINETIK: 'KINETIK',
  LYFT: 'LYFT',
  UBER: 'UBER',
  EXPORT: 'EXPORT',
});

/** Human-readable labels for the `assignmentIntakeMethods.trips` enum (displayed in UI). */
export const ASSIGNMENT_INTAKE_METHOD_TRIPS_LABELS = Object.freeze({
  [ASSIGNMENT_INTAKE_METHOD_TRIPS.KINETIK]: 'Kinetik',
  [ASSIGNMENT_INTAKE_METHOD_TRIPS.LYFT]: 'Lyft',
  [ASSIGNMENT_INTAKE_METHOD_TRIPS.UBER]: 'Uber',
  [ASSIGNMENT_INTAKE_METHOD_TRIPS.EXPORT]: 'Export',
});
